import React from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "includes/Heading";
import { PrimaryButton as PrimaryButtonBase } from "includes/Buttons";
import { ReactComponent as ChevronLeftIcon } from "feather-icons/dist/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "feather-icons/dist/icons/chevron-right.svg";

const Container = tw.div`relative `;
const Content = tw.div`max-w-screen-xl mx-auto   `;

const HeadingWithControl = tw.div`flex flex-col items-center sm:items-stretch sm:flex-row justify-between`;
const Heading = tw(SectionHeading)``;
const Controls = tw.div`flex items-center`;
const ControlButton = styled(PrimaryButtonBase)`
  ${tw`mt-4 sm:mt-0 first:ml-0 ml-6 rounded-full p-2`}
  svg {
    ${tw`w-6 h-6`}
  }
`;
const PrevButton = tw(ControlButton)``;
const NextButton = tw(ControlButton)``;

const CardSlider = styled(Slider)`
  ${tw`mt-16`}
  .slick-track { 
    ${tw`flex`}
  }
  .slick-slide {
    ${tw`h-auto flex justify-center mb-1`}
  }
`;
const Card = tw.div`h-full flex! flex-col sm:border max-w-sm sm:rounded-tl-4xl sm:rounded-br-5xl relative focus:outline-none`;
const CardImage = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`w-full h-56 sm:h-64 bg-cover bg-center rounded sm:rounded-none sm:rounded-tl-4xl`
]);

const TextInfo = tw.div`py-6 sm:px-10 sm:py-6`;
const TitleReviewContainer = tw.div`flex flex-col sm:flex-row sm:justify-between sm:items-center`;
const Title = tw.h5`text-2xl font-bold`;

const RatingsInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`w-6 h-6 text-yellow-500 fill-current`}
  }
`;
const Description = tw.p`text-sm leading-loose mt-2 sm:mt-4`;

export default class Service extends React.Component {


  cards = [];
  sliderSettings = {
    arrows: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
        }
      },

      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  };


  slickPrev() {
    this.slider.slickPrev();
  }
  slickNext() {
    this.slider.slickNext();
  }

  constructor(props) {
    super(props);
    this.state = {
      sliderRef: null,
      setSliderRef: () => {}
  };
    this.slickPrev = this.slickPrev.bind(this);
    this.slickNext = this.slickNext.bind(this);
    const cards = [];

    props.listData.forEach((single) => {
      cards.push({
        imageSrc: single.image,
        title: single.title,
        description: single.detail
      })
    });
    this.cards = cards;
  }

  componentDidMount() {
  }

  render() {

    return (
        <Container className="slider-service w-80">
          <Content>
            <HeadingWithControl>
              <Heading>Our Best Services</Heading>
              <Controls>
                <PrevButton onClick={this.slickPrev}><ChevronLeftIcon/></PrevButton>
                <NextButton onClick={this.slickNext}><ChevronRightIcon/></NextButton>
              </Controls>
            </HeadingWithControl>
            <CardSlider ref={ slider =>( this.slider = slider)} {...this.sliderSettings}>
              {this.cards.map((card, index) => (
                  <Card key={index}>
                    <CardImage imageSrc={card.imageSrc} />
                    <TextInfo>
                      <TitleReviewContainer>
                        <Title>{card.title}</Title>
                        <RatingsInfo>
                        </RatingsInfo>
                      </TitleReviewContainer>
                      <Description>{card.description}</Description>
                    </TextInfo>
                  </Card>
              ))}
            </CardSlider>
          </Content>
        </Container>
    );

  }
}
